import React from 'react'
import { SelectDropdown, Wrapper } from 'SRC/ui/FormElementsNew'

import { connect as formikConnect } from 'formik'
import config from 'SRC/config/config.yaml'

class PriceTypeForAddons extends React.Component {
	onPriceTypeForAddonsChange = priceTypeForAddons => {
		const { formik } = this.props
		const { adPriceTypes } = config.adForm
		const value = Number(priceTypeForAddons)

		if (value) {
			switch (value) {
				case adPriceTypes.retail.id:
					formik.setFieldValue('priceFrom', -1)
					formik.setFieldValue('priceTo', -1)
					break
				case adPriceTypes.fromTo.id:
					formik.setFieldValue('price', -1)
					formik.setFieldValue('discountedPrice', -1)
					break
				default:
					formik.setFieldValue('price', -1)
					formik.setFieldValue('discountedPrice', -1)
					formik.setFieldValue('priceFrom', -1)
					formik.setFieldValue('priceTo', -1)
					break
			}
		}
	}

	render() {
		const { formik, options } = this.props

		return (
			<Wrapper>
				<SelectDropdown
					id='priceTypeForAddons'
					title='Vrsta cijene'
					isSearchable={false}
					isOptional={false}
					value={formik.values.priceTypeForAddons}
					options={options}
					onChange={priceTypeForAddons => {
						console.log('PriceTypeForAddons selected', priceTypeForAddons)

						this.onPriceTypeForAddonsChange(priceTypeForAddons)
						formik.setFieldValue('priceTypeForAddons', priceTypeForAddons)
					}}
				/>
			</Wrapper>
		)
	}
}

export default formikConnect(PriceTypeForAddons)
